import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { Modal } from '../../../../../components';
import type { ActionCardPayload } from './KnowledgeCard';
import { formatMetadataValue } from '../../utils/formatMetadata';
import { METADATA_FIELD_LABELS } from '../../utils/const';

export const KnowledgeMetadataModal = ({
  isOpenedShowMetadataModal,
  onCloseShowMetadataModal,
  actionPayload,
}: {
  isOpenedShowMetadataModal: boolean;
  onCloseShowMetadataModal: () => void;
  actionPayload: ActionCardPayload | null;
}) => {
  const metadataFields = Object.entries(
    actionPayload?.metadata_fields || {}
  ).map(([key, value]) => {
    const label = METADATA_FIELD_LABELS[key] || key;
    const formattedValue = formatMetadataValue(value as string);

    return (
      <div key={key} className="w-full flex flex-col">
        <span className="text-medium font-semibold text-gray-500 whitespace-nowrap pb-2 block">
          {label}:
        </span>
        <div className="prose prose-sm max-w-none text-gray-500 text-tiny">
          {formattedValue ? (
            <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>
              {formattedValue}
            </Markdown>
          ) : (
            <span className="text-gray-400 italic">—</span>
          )}
        </div>
      </div>
    );
  });

  return (
    <Modal
      title="Metadata"
      open={isOpenedShowMetadataModal}
      onClose={onCloseShowMetadataModal}
      size="medium"
    >
      {actionPayload?.metadata_fields ? (
        <div className="p-6 flex flex-col gap-4">{metadataFields}</div>
      ) : (
        <div className="p-6 flex flex-col gap-4  bg-gray-100 rounded-card">
          <span className="text-gray-400 text-medium">
            No metadata fields available
          </span>
        </div>
      )}
    </Modal>
  );
};
